export class MonthlySnapshotData {
    'month';
    'totalCount';
    'clusterCount';
    'snapshotsPerVault';
    'nonEonSnapshotCount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "month",
            "baseName": "month",
            "type": "number",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "clusterCount",
            "baseName": "clusterCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "snapshotsPerVault",
            "baseName": "snapshotsPerVault",
            "type": "Array<VaultSnapshotCount>",
            "format": ""
        },
        {
            "name": "nonEonSnapshotCount",
            "baseName": "nonEonSnapshotCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MonthlySnapshotData.attributeTypeMap;
    }
    constructor() {
    }
}
